module.exports = __webpack_public_path__ + "assets/img/no_comment.70f7bccd.png";